import { memo, useContext, useEffect, useMemo } from "react"
import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css"
import ".././inner.css"
import Servicebox from "./Servicebox"
import Servicebanner from "./Servicebanner"
import Scrolltop from "../Scrolltop"
// import Mobcontroller from "../Mainbox/ContactButton/Mobcontroller"
import ContactButton from "../Mainbox/ContactButton/ContactButton"
import Mobmenu from "../Mobmenu"
import Footer from "../Mainbox/Footer"
import { data } from "../../App"
import Subjectservice from "./Subjectservice"

function Service(){
    const serviceseta=useContext(data);
    const currentService = useMemo(() => {
        return Subjectservice.find((item) => item.name === serviceseta);
    }, [serviceseta]);

    useEffect(()=>{
        window.scrollTo({top:"0px"})
    },[serviceseta])
    return (<>
    <Scrolltop/>
    {/* <Mobcontroller/> */}
    <ContactButton/>
    <Mobmenu/>
    <div>
      <Servicebanner
        bannerimg={currentService?.bannerimg ?? "orthopedicbanner"}
        bannername={currentService?.bannername ?? serviceseta}
      />
      <div className="serviceouter">
        <Servicebox service={currentService?.service} />
      </div>
    </div>
    <Footer/>
    </>)
}
export default memo(Service)
